import { useLocation } from 'react-router-dom';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { useLocalization } from '../../../Contexts/Localization';
import { useSetMessage } from '../../../Contexts/Message';
import { GMButton } from '../../../CommonControls/Buttons/Button';
import { GMGrid } from '../../../CommonControls/Grid/Grid';
import { ContactSupport } from '../ContactSupport/ContactSupportModal';
import { AppRoutes } from '../../../CommonUtils/Routes';
import { useIsMobile, useIsTablet } from '../../../CommonUtils/MediaQueries';
import css from './DashboardFooter.module.scss';

export const DashboardFooter: GoMotoComponent = () => {
    const Localization = useLocalization();
    const location = useLocation();
    const setMessage = useSetMessage();
    const isMobile = useIsMobile();
    const isTablet = useIsTablet();

    if (isMobile || isTablet || location.pathname.includes(AppRoutes.Preferences)) {
        return null;
    }
    else {
        return (
            <GMGrid className={css.root}>
                <GMButton
                    buttonType={'text'}
                    onClick={() => setMessage({
                        title: Localization.ContactSupport,
                        message: <ContactSupport />,
                    })}
                    margin={'none'}
                    size={'small'}
                >
                    {Localization.ContactSupport}
                </GMButton>
            </GMGrid>
        );
    }
};
